import React, { Suspense, lazy, useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '@qualtrics/ui-react';
import { Layout } from './Layout';
import pages from '../../pages';

const ToolbarFullPageExample = lazy(() =>
    import('../../pages/Components/ToolbarPage/fullPageExample/example')
);
const ToolbarFullPageExampleCode = lazy(() =>
    import('../../pages/Components/ToolbarPage/fullPageExample/code')
);
const PageLayoutFullPageExample = lazy(() =>
    import('../../pages/Next/PageLayoutPage/fullPageExample/example')
);
const PageLayoutFullPageExampleCode = lazy(() =>
    import('../../pages/Next/PageLayoutPage/fullPageExample/code')
);
const LogicEditorFullyFeaturedExampleCode = lazy(() =>
    import(
        '../../pages/Components/LogicEditorPage/examples/AdvancedLogicEditor/code'
    )
);

const FallbackLoadingSpinner = () => {
    return <LoadingSpinner className="w-full h-full" show size="large" />;
};

function reloadSiteIntercept() {
    if (window.QSI) {
        window.QSI.API.unload();
        setTimeout(() => {
            window.QSI.API.load();
        }, 500);
    }
}

const App = () => {
    const location = useLocation();
    useEffect(() => {
        reloadSiteIntercept();
    }, [location]);

    function getRoutes(routes) {
        return routes.map(({ title, path, content: Component, children }) => {
            if (children) {
                return getRoutes(children);
            }

            return (
                <Route
                    key={path}
                    path={path}
                    magic="6"
                    render={props => (
                        <Component pageData={{ title }} {...props} />
                    )}
                />
            );
        });
    }

    return (
        <Switch>
            <Route
                path="/page-layout/full-page-example/code"
                exact
                render={() => (
                    // The container div is used to center the loading spinner
                    <div style={{ width: '100vw', height: '100vh' }}>
                        <Suspense fallback={<FallbackLoadingSpinner />}>
                            <PageLayoutFullPageExampleCode />
                        </Suspense>
                    </div>
                )}
            />
            <Route
                path="/page-layout/full-page-example"
                exact
                render={() => (
                    // The container div is used to center the loading spinner
                    <div style={{ width: '100vw', height: '100vh' }}>
                        <Suspense fallback={<FallbackLoadingSpinner />}>
                            <PageLayoutFullPageExample />
                        </Suspense>
                    </div>
                )}
            />
            <Route
                path="/toolbar/full-page-example/code"
                exact
                render={() => (
                    // The container div is used to center the loading spinner
                    <div style={{ width: '100vw', height: '100vh' }}>
                        <Suspense fallback={<FallbackLoadingSpinner />}>
                            <ToolbarFullPageExampleCode />
                        </Suspense>
                    </div>
                )}
            />
            <Route
                path="/toolbar/full-page-example"
                exact
                render={() => (
                    // The container div is used to center the loading spinner
                    <div style={{ width: '100vw', height: '100vh' }}>
                        <Suspense fallback={<FallbackLoadingSpinner />}>
                            <ToolbarFullPageExample />
                        </Suspense>
                    </div>
                )}
            />
            <Route
                path="/logic-editor/fully-featured-example/code"
                exact
                render={() => (
                    // The container div is used to center the loading spinner
                    <div style={{ width: '100vw', height: '100vh' }}>
                        <Suspense fallback={<FallbackLoadingSpinner />}>
                            <LogicEditorFullyFeaturedExampleCode />
                        </Suspense>
                    </div>
                )}
            />
            <Route>
                <Layout>
                    <Suspense fallback={<FallbackLoadingSpinner />}>
                        <Switch>
                            {getRoutes(pages)}
                            <Redirect from="/" to="/getting-started" />
                        </Switch>
                    </Suspense>
                </Layout>
            </Route>
        </Switch>
    );
};

export default App;
